import { render, staticRenderFns } from "./product-dialog.vue?vue&type=template&id=f7c9c82e&"
import script from "./product-dialog.vue?vue&type=script&lang=js&"
export * from "./product-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports